// src/engine/engineFlag.js
// Whether the app talks to the offline engine on this device instead of the server. Off unless switched on with
// ?engine=local in the address (and back off with ?engine=server); remembered in the browser.
import { guestActive } from '../guest';

const KEY = 'tournamental.localEngine';

// Whether this device has been switched to offline mode (by the user or with ?engine=local).
export function offlineModeOn() {
    try {
        return window.localStorage.getItem(KEY) === '1';
    } catch (error) {
        return false;
    }
}

// Whether the app's requests are answered on this device. A guest always works on the device: there is no account to
// talk to the server about.
export function localEngineEnabled() {
    return offlineModeOn() || guestActive();
}

export function applyEngineFlagFromUrl() {
    try {
        const choice = new URLSearchParams(window.location.search).get('engine');
        if (choice === 'local') window.localStorage.setItem(KEY, '1');
        if (choice === 'server') window.localStorage.removeItem(KEY);
    } catch (error) {
        // no storage: nothing to remember
    }
}

export function setLocalEngine(on) {
    try {
        if (on) window.localStorage.setItem(KEY, '1');
        else window.localStorage.removeItem(KEY);
    } catch (error) {
        // no storage: the choice cannot be remembered
    }
}
